import React from 'react';
import { Search } from 'lucide-react';

const CandidateSearch = () => (
  <div className="text-center py-20">
    <Search className="mx-auto text-gray-400 mb-4" size={64} />
    <h2 className="text-2xl font-semibold text-gray-700">Find Candidates</h2>
    <p className="text-gray-500">Advanced candidate search coming soon...</p>
  </div>
);

export default CandidateSearch;
